import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import CmnActionButtons from "../shared/cmnActionButtons";
import PendingCmnsTab from "../myFacilities/pendingCmnsTab";
import ProviderInfoTab from "./providerInfoTab";

/**
 * Provider Dashboard — shown inside PopupModal when a provider is selected.
 * Contains:
 *  - Persistent action buttons (Download CMNs, Send via DocuSign, Send via Fax)
 *  - 2 sub-tabs: Provider Information | Pending CMNs
 */
function ProviderDashboard({ physicianId, providerName }) {
  return (
    <div className="cmn-dashboard">
      <CmnActionButtons contextType="provider" contextId={physicianId} />
      <Tabs defaultActiveKey="providerInfo" id={`provider-dashboard-tabs-${physicianId}`} className="mb-2 cmn-dashboard-tabs">
        <Tab eventKey="providerInfo" title="Provider Information">
          <ProviderInfoTab physicianId={physicianId} />
        </Tab>
        <Tab eventKey="pendingCmns" title="Pending CMNs">
          <PendingCmnsTab facilityId={0} physicianId={physicianId} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default ProviderDashboard;
